import React, { RefObject } from "react";
import { connect } from "react-redux";
import axios from "axios";
import size from "lodash/size";
// import { AppError, ErrorCode } from "../models/applicationState";
import LoadingOverlay from "react-loading-overlay";
import { bindActionCreators } from "redux";
import { Spinner, SpinnerSize } from "office-ui-fabric-react/lib/Spinner";
import Confirm from "../../common/confirm/confirm";
import { generateKey } from "../../../../common/crypto";
import { RouteComponentProps } from "react-router-dom";
import { getPrimaryRedTheme } from "../../../../common/themes";
import { IProject, IApplicationState, IAuthenticationState, IAzureFields } from "../../../../models/applicationState";
import IConnectionActions, * as connectionActions from "../../../../redux/actions/connectionActions";
import IApplicationActions, * as applicationActions from "../../../../redux/actions/applicationActions";
import IProjectActions, * as projectActions from "../../../../redux/actions/projectActions";
import IUserModelActions, * as userModelActions from "../../../../redux/actions/modalActions";
import ServiceHelper from "../../../../services/serviceHelper";
import moment from "moment";
import HeaderComponent from "../header/header";

export interface IMyModelsProps extends RouteComponentProps, React.Props<MyModels> {
    project: IProject;
    recentProjects: IProject[];
    loggedInUser: IAuthenticationState;
    path: object;
    projectActions: IProjectActions;
    userModelActions: IUserModelActions;
    userModels: any;
}

function mapStateToProps(state: IApplicationState) {
    return {
        project: state.currentProject,
        loggedInUser: state.loggedInUser,
        recentProjects: state.recentProjects,
        userModels: state.loadModels,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        projectActions: bindActionCreators(projectActions, dispatch),
        userModelActions: bindActionCreators(userModelActions, dispatch),
    };
}

export interface IMyModelsState {
    myModels: any[];
    spinnerString: string;
    loadModal: boolean;
    searchText: null;
    allData: any[];
    userId: string;
}

@connect(mapStateToProps, mapDispatchToProps)

export default class MyModels
    extends React.Component<IMyModelsProps, IMyModelsState> {
    public state: IMyModelsState = {
        myModels: [],
        spinnerString: "Loading Models",
        loadModal: false,
        searchText: null,
        allData: [],
        userId: null,
    };

    private deleteProjectConfirm: React.RefObject<Confirm> = React.createRef();
    private deleteProjectCanceled: () => void;
    private isUnmount: boolean = false;

    public async componentDidMount() {
        this.isUnmount = false;
        const user = this.props.loggedInUser;
        const userId = user.user.oid;
        console.log(this.props);
        await this.setState({ loadModal: true, userId });
        localStorage.removeItem("lastVisttedtestAssetId");
        localStorage.removeItem("filesLength");
        localStorage.removeItem("testFilesLengthFromTest");
        localStorage.removeItem("filesLengthFromModel");
        this.props.projectActions.clearStoredExistingModelOcrFiles();
        this.setState({ loadModal: true });
        const modelData = await this.props.userModelActions.loadUserModels();
        this.setState({ loadModal: false, myModels: modelData,  allData: modelData});
    }

    public componentWillUnmount() {
        this.isUnmount = true;
        console.log(this.props, "*****un mount****");
        // alert("Hello");
        // if (window.event:) {
        //     if (window.event.clientX < 40 && window.event.clientY < 0) {
        //         alert("Clicked - Browser back button.");
        //     } else {
        //         alert("Clicked - Browser refresh button.");
        //     }
        // }
        /* else {
            if (event.currentTarget.performance.navigation.type === 2) {
                alert("Clicked - Browser refresh button.");
            } else if (event.currentTarget.performance.navigation.type === 1) {
                alert("Clicked - Browser back button.");
            }
        }; */
    }

    public removeStringLastComma = (index, labels, label) => {
        let labelString = `${label}, `;
        if (index === size(labels) - 1) {
            labelString = label;
        }
        return labelString;
    }

    public intialProject = (model) => {
        const connection = { id: null, name: null, providerType: "azureBlobStorage", providerOptions: {} };
        connection.providerOptions["sas"] = IAzureFields.sasUrl;
        localStorage.setItem("project_name", model.project_name);
        const project = {
            id: "",
            name: `${model.project_name}`,
            version: "",
            securityToken: "token",
            tags: [],
            sourceConnection: connection,
            lastVisitedAssetId: "",
            tableTags: [],
            fromModel: true,
            apiUriBase: IAzureFields.endPoint,
            apiKey: IAzureFields.key,
            folderPath: `${model.project_name}-${this.state.userId}/training`,
            projType: model.type.toLocaleLowerCase(),
            assets:{},
        };
        return project;
    }

    public goToModel = async (model) => {
      
        if (size(this.props.recentProjects) > 0) {
            const recentProject = await this.props.recentProjects.find((project) => project.name === model.project_name);
            const projectCopy = recentProject ? Object.assign({}, recentProject) : this.intialProject(model);
            projectCopy.folderPath = `${model.project_name}-${this.state.userId}/training`;
            projectCopy.fromModel = true;
            projectCopy.tags=[];
            projectCopy.assets={};
            this.routeToAnnotatePage(projectCopy, model);
        } else {
            this.routeToAnnotatePage(this.intialProject(model), model);
        }
    }

    public routeToAnnotatePage = async (project, model) => {
        const data = await this.props.projectActions.saveProject(project, false, false);
       /* if (data && data.id) {
            localStorage.setItem("trainResult", "true");
            this.props.history.push(`/projectsFR/${model.project_name}/${data.id}/edit/na`);
        }*/

        if (data && data.id) {
            localStorage.setItem("trainResult", "true");           
             if (model && model.type.toLocaleLowerCase() === "od") {
                this.props.history.push(`/ODProjects/${model.project_name}/${data.id}/od/edit/na`);
            } else {
                this.props.history.push(`/OCRProjects/${model.project_name}/${data.id}/ocr/edit/na`);            
            }
        }
    }

    public deleteModel = (model) => {
        /** Confirm to delete Project */
        this.deleteProjectConfirm.current.open(model);
    }

    public searchSpace = (e) => {
        const keyword = e.target.value;
        this.setState({ searchText: keyword });
        if (keyword === "") {
            this.setState({ myModels: this.state.allData });
            this.tableDataShow();
        } else {
            const data = this.state.myModels;
            const filteredItems = data.filter(
                (item) =>
                    item.project_name.toLocaleLowerCase().includes(keyword),
            );
            this.setState({ myModels: filteredItems });
        }
    }

    public tableDataShow = () => {
        const { myModels, loadModal, spinnerString } = this.state;
      //  console.log("my models ==>"+JSON.stringify(myModels));
        return (
            <div>
                {myModels && size(myModels) > 0 ?
                    <div className="card wrap-body-my_models shadow model-data mt-2">
                        <table className="table table-dark table-striped">
                            <thead>
                                <tr>
                                    <th>Model Name</th>
                                    <th>Type</th>
                                    <th>Date</th>
                                    <th>Label</th>
                                    <th>Accuracy</th>
                                    <th>Summary</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {myModels && myModels.map((model, index) => {
                                    const accuracy = (model.accuracy * 100).toFixed(2); 
                                    const modellbs =  model.labels.split('$$$')[0];                                  
                                    const lbl1 = modellbs.split("{");
                        const AllLabels =[];                                    
                        lbl1.forEach((lblval) =>{
                                        if (lblval.includes("fieldName")) {                                           
                                           const lbl3 =lblval.split('fieldName');
                                         const lbl4 =lbl3[1].split(',');
                                          const lbl5 =lbl4[0].split(':');
                                          const lbl6 = lbl5[1].trim().replace("'","");
                                            AllLabels.push(lbl6.substr(0,lbl6.length-1));
                                        }  
                                });  

                                let title;
                                let modelType;
                                if (model.type === "OD") {

                                    modelType = "OD";
                                    title = "Object Detection";
                                } else if  (model.type === "OCR") {
                                    modelType = "OCR";
                                    title = "Optical Character Recognition";
                                } else  {
                                    modelType = "IM";
                                    title = "Image Classification";
                                }

                                    //
                                   /* let modelType;
                                    let title;
                                    if (index === 1) {
                                        modelType = "IM";
                                        title = "Image Classification";
                                    } else if (index === 0) {
                                        modelType = "OD";
                                        title = "Object Detection";
                                    } else {
                                        modelType = model.OCR;
                                        title = "Optical Character Recognition";
                                    }*/
                                    return (
                                        <tr key={index}>
                                            <td>{model.project_name}</td>
                                            <td title={title}>{model.type}</td>
                                            <td>{moment(model.created_date, "YYYY-MM-DD HH:mm:ss").format("DD-MMM-YYYY")}</td>
                                            <td ><div className="scrollable">{size(model.labels) > 0 ? AllLabels.map((label, index) => {
                                                return (
                                                    <span key={index}>
                                                        {this.removeStringLastComma(index, AllLabels, label)}
                                                    </span>);
                                            }) : <span>No labels are Available</span>}
                                            </div>
                                            </td>
                                            <td>{model.type==="OCR"?accuracy:"100.00"}%</td>
                                            <td>{model.hosted}</td>
                                            <td className="action-control">
                                                <button role="button" className="view"
                                                    onClick={() => this.goToModel(model)}>
                                                    <i className="fa fa-eye bg-color-1" aria-hidden="true"></i>
                                                </button>
                                                <button role="button" className="delete"
                                                    onClick={() => this.deleteModel(model)}>
                                                    <i className="fa fa-trash bg-color-1" aria-hidden="true"></i>
                                                </button>

                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    : <p className="text-center">No Data Available</p>}
            </div>
        );
    }

    public render() {
        const { myModels, loadModal, spinnerString } = this.state;
        return (
            <>
                 <HeaderComponent
                history={this.props.history}
                match={this.props.match}
                location={this.props.location} />
                <LoadingOverlay
                    active={loadModal}
                    spinner
                    className={loadModal ? "wrap-queue-height" : ""}
                    text="loading Your Models."
                >
                    <div className="container-fluid animated fadeIn">
                        <div className="row mt-2">
                            <div className="col-md-3">
                                <div className="input-group input-group-sm my-model-filter ">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <i className="fas fa-search"></i>
                                        </span>
                                    </div>
                                    <input type="text" placeholder="search" onChange={(e) => this.searchSpace(e)} className="form-control" />
                                </div>
                            </div>
                            <div className="col-md-7">
                            </div>
                            <div className="col-md-2">
                                <button className="btn-custom float-right" onClick={() => this.updateModels(true)}>
                                    <i className="fas fa-sync-alt"></i> Refresh </button>
                            </div>
                        </div>
                        {this.tableDataShow()}
                        <Confirm title="Delete Project"
                            ref={this.deleteProjectConfirm}
                            message="Are you sure you want to delete this Project ?"
                            confirmButtonTheme={getPrimaryRedTheme()}
                            onCancel={this.onDeleteProjectCancel}
                            onConfirm={this.onDeleteProject} />
                    </div>
                </LoadingOverlay>
            </>
        );
    }

    private onDeleteProjectCancel = () => {
        if (this.deleteProjectCanceled) {
            this.deleteProjectCanceled();
            this.deleteProjectCanceled = null;
        }
    }

    /**
     * Deleting model
     */
    private onDeleteProject = async (model) => {
        this.setState({ spinnerString: "Deleting Model", loadModal: true });
        const recentProject = this.props.recentProjects.find((project) => project.name === model.project_name);
        await this.props.userModelActions.deleteUserModel(model, recentProject);
        this.updateModels();
    }

    /**
     * get updated models
     */
    private updateModels = async (flag?: boolean) => {
        this.setState({ loadModal: true });
        const modelData = await this.props.userModelActions.loadUserModels(flag);
        this.setState({ loadModal: false, myModels: modelData });
    }
}
